export default "__VITE_ASSET__CGfkZHYx__"